import { Typography } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetMapitShipOrdersByIdQuery, useLazyGetDeliveryCompaniesQuery, useUpdateMapitShipOrderMutation } from 'src/_api/mapitShipApi';
import { $APP_NAME } from 'src/constants';
import { DeliveryCompaniesListContainer, OrderShipmentDetailsCard } from './components';
import { useEffect, useState } from 'react';
import OrdrContextProvider from './OrdrContextProvider';
import { Warning } from '@mui/icons-material';

export default function PriceCalculator() {
    const { t } = useTranslation();
    const { orderId } = useParams();

    const [isEditing, setIsEditing] = useState(false);

    const { data: order, isLoading: orderLoading } = useGetMapitShipOrdersByIdQuery(orderId)

    const isEditingChangeHandler = (value) => {
        setIsEditing(value)
    }

    //======= Update order with shipment details =======
    const [
        getDeliveryCompanies,
        {
            data: companies,
            isLoading: companiesLoading
        }
    ] = useLazyGetDeliveryCompaniesQuery();

    const [updateOrder, { isLoading, reset }] = useUpdateMapitShipOrderMutation()

    const saveShipmentsHandler = async (payload) => {
        try {
            await updateOrder(payload).unwrap()

            setIsEditing(false)

            await getDeliveryCompanies(order?.id).unwrap()

            setTimeout(() => {
                reset()
            }, 2000)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (!!orderId) {
            getDeliveryCompanies(orderId)
        }
    }, [orderId])

    return (
        <>
            <Helmet>
                <title>Price calculator | {$APP_NAME}</title>
            </Helmet>
            <Typography variant="h2" sx={{ mb: 2 }}>{t("Assign Shipping Company")}</Typography>
            <OrdrContextProvider order={order} orderLoading={orderLoading}>
                <OrderShipmentDetailsCard
                    isEditing={isEditing}
                    isEditingChangeHandler={isEditingChangeHandler}
                    order={order}
                    onSaveShipment={saveShipmentsHandler}
                    loading={isLoading || companiesLoading}
                    closeEditCards={!!companies}
                    selected={true}
                />
                {
                    !isEditing &&
                    <DeliveryCompaniesListContainer
                        companies={companies}
                        companiesLoading={companiesLoading}
                        orderId={orderId}
                    />
                }
            </OrdrContextProvider>
        </>
    )
}
